export default __webpack_public_path__ + "static/media/No_Image_Available.e1ce751e.jpg";